import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopCategoryHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopProductList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/render/project/src/refgd/node_modules/next/dist/client/app-dir/link.js");
